import { NestedColumnType } from '@/apis/types'

export const YAYASAN_TABLE_COLUMN: NestedColumnType[] = [
  {
    id: 'no',
    displayName: 'No',
    childColumns: [],
  },
  {
    id: 'npyp',
    displayName: 'NPYP',
    childColumns: [],
  },
  {
    id: 'namaYayasan',
    displayName: 'Nama Yayasan',
    childColumns: [],
  },
  {
    id: 'alamatJalan',
    displayName: 'Alamat',
    childColumns: [],
  },
  {
    id: 'jenisYayasan',
    displayName: 'Jenis',
    childColumns: [],
  },
  {
    id: 'namaDesa',
    displayName: 'Kelurahan',
    childColumns: [],
  },
  {
    id: 'jumlahSekolahNaungan',
    displayName: 'Sekolah Naungan',
    childColumns: [],
  },
]

export const YAYASAN_MAP_COLUMN_TO_SORT_PARAM = {
  namaDesa: 'nama_desa',
  jumlahSekolahNaungan: 'jumlah_sekolah_naungan',
}

export const YAYASAN_MAP_SORT_PARAM_TO_COLUMN = {
  nama_desa: 'namaDesa',
  jumlah_sekolah_naungan: 'jumlahSekolahNaungan',
}
